import { render, staticRenderFns } from "./open-sign.vue?vue&type=template&id=04e5877c&scoped=true&"
import script from "./open-sign.vue?vue&type=script&lang=js&"
export * from "./open-sign.vue?vue&type=script&lang=js&"
import style0 from "./open-sign.vue?vue&type=style&index=0&id=04e5877c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04e5877c",
  null
  
)

export default component.exports